<app-keenicon name="arrow-up" class=""></app-keenicon>
